module.exports = __webpack_public_path__ + "static/media/cuentacorriente.2ffcb6dd.svg";